import { render } from "./ServiceItsLocationComp.vue?vue&type=template&id=b58b81a2&scoped=true"
import script from "./ServiceItsLocationComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsLocationComp.vue?vue&type=script&lang=js"

import "./ServiceItsLocationComp.vue?vue&type=style&index=0&id=b58b81a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58b81a2"]])

export default __exports__